export default (content) => {
    
    
    // console.log(obj);
    
    // let content = Object.assign(defaultobj, obj);
    // console.log(content,obj);
    
    return `
                  
        <div class="row everyother highlight__row" data-order="${content.order}">
            <div class="col-1 col-lg-2 col-xl-1  vertical ${content.right === true ? "offset-lg-1 order-12 vertical-right text-right" : " vertical-left"}">
                <div class="vline"></div>
                <span class="d-none d-lg-flex spin circle ${content.right === true ? "circle-right" : ""}  "><span class="counterspin_text highlight__year">${content.year}</span></span>
            
            </div>
            <div class="col-11 col-lg-9 col-xl-10 ${content.right === true ? " " : "offset-lg-1"} highlight__section ${content.first ? "highlight__section-first" : ""}">
                <div class="row row-eq-heigh">
                    <div class="col-lg-5 order-12 ${content.right === true ? "order-lg-12 offset-lg-1" : "order-lg-0 "} ">
                        <div class="highlight__textcontent">
                            <h1 class="highlight__title">${content.title}</h1>
                            <div class="highlight__intro">
                                ${content.intro}
                                <div>
                                    <a href="/${site}/${content.url}" class="highlight__more"><span class="material-icons-outlined highlight__moreicon">arrow_forward</span><span class="highlight__moretext">Mer om ${content.year}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="${content.right === true ? "col-lg-6  " : "offset-lg-1 col-md-6 "} highlight__imagecontainer">
                        <div class="highlight__imagecontent">
                            ${content.images}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 horizon-container" >
                <div style="position:relative" >
                    <div class="horizon ${content.right === true ? "horizon-ltr" : "horizon-rtl"}" data-text="${content.right === true ? "horizon-ltr" : "horizon-rtl"}"></div>
                    
                    <span class="d-flex d-lg-none spin circle ${content.right === true ? "circle-right" : ""}  "><span class="counterspin_text highlight__year">${content.year}</span></span>
            
                </div>
            </div>
        </div>
        `;
    
}
export const highlightCondenced = (content) => {
    
    if(content.images) {
        let tempHTML = new DOMParser();
        let tempHTMLintro = tempHTML.parseFromString(content.intro, "text/html");
        
        // console.warn(content.images);
        tempHTMLintro.querySelectorAll("img").forEach(img => {
            // console.warn("has images", img.getAttribute("src"));
            if(content.images.match(img.getAttribute('src'))){
                
                // console.warn("has image match!" );
                img.remove();
            }
        });
        
        content.intro = tempHTMLintro.querySelector("body").innerHTML;
        
    }
    
    return `
                 
        <div class="row everyother highlight__row" data-order="${content.order}">
            <div class="col-1 col-lg-2 col-xl-1  vertical vertical-condenced  vertical-left">
                <div class="vline"></div>
                <span class="spin circle circle__mobile circle__condenced "><span class="counterspin_text highlight__year">${content.year}</span></span>
            
            </div>
            <div class="col-10 offset-1 col-lg-9 col-xl-10 offset-lg-1 highlight__section ${content.first ? "highlight__section-first" : ""}">
                <div class="row row-eq-heigh">
                    <div class="${content.images.length > 0 ? `col-lg-8`: "col-lg-12"} order-lg-0 ">
                        <div class="highlight__textcontent highlight__textcontent-condenced">
                            <h1 class="highlight__title">${content.title}</h1>
                            <div class="highlight__intro">
                                ${content.intro}
                            </div>
                        </div>
                    </div>
                    ${content.images.length > 0 ? `
                    <div class="col-lg-4 highlight__imagecontainer">
                        <div class="highlight__imagecontent">
                            ${content.images}
                        </div>
                    </div>
                    ` : ""}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 horizon-container d-none" >
                <div style="position:relative" >
                    <div class="horizon horizon-rtl data-text="horizon-ltr"></div>
                    
                    <span class="d-flex d-lg-none spin circle"><span class="counterspin_text highlight__year">${content.year}</span></span>
            
                </div>
            </div>
        </div>
        
    `
}

export const highlightImages = (image) => {
    return `
        <img src="//res.cloudinary.com/ssp/image/fetch/g_center,w_450,f_webp,c_fill/${image.src}" data-id="${image.dataid}" alt="${image.alt}" class="highlight__img highligh__img-${image.type} ${image.cssclass}">
    `;
}
export const highlightImageCondenced = (image) => {
    // console.log("image", "'"+image.src+"'",image.src !== "undefined", image.src !== "");
    if(image.src !== "undefined" && image.src !== "" ){
        return `
            <img src="//res.cloudinary.com/ssp/image/fetch/g_center,w_450,f_webp,c_fill/${image.src}" data-id="${image.dataid ? image.dataid : ""}" alt="${image.alt ? image.alt : ""}" class="highlight__img highligh__img-condenced ">
        `;
    }
    else {
        return `<!-- Invalid image -->`;
    }
}

export const initHighlight = () => {
    return `
        <div class="row justify-content-center">
            <div class="col col-md-10">
                <div  id="site_highlight"></div>
            </div>
        </div>
    `
} 

export const nextPrevHtml = (prev, next) => {
    
    
    return `
    
        <div class="row pageing">
            <div class="col-6">
                ${prev ? `
                <a href="${prev.url}" class="pageing__link pageing__link-prev text-lg-right"><span class="material-icons-outlined pageing__icon pageing__icon-left">arrow_backward</span><span class="pageing__linktext">${prev.title}</span></a>
                ` : ``}
            </div>
            <div class="col-6">
                ${next ? `
                <a href="${next.url}" class="pageing__link pageing__link-next"><span class="material-icons-outlined pageing__icon pageing__icon-right">arrow_forward</span><span class="pageing__linktext">${next.title}</span></a>
                ` : ``} 
            </div>
            
        </div>
    
    `
    
}